// AI Money Factory homework + module map (Dew, 2026-10-19). One homework per module,
// submitted on the การบ้าน + Quiz page. Wording comes from work/lms/ai-sales-system/homework.md
// (old "Level" numbers mapped to today's Module 1-7). Pure and SDK-free.

export type AmfModule = { n: number; title: string; courseId: string };

/** Which course card holds each module (a student needs that card to submit its quiz/homework). */
export const AMF_MODULES: AmfModule[] = [
  { n: 1, title: "หาของที่จะขาย", courseId: "ai-sales-system" },
  { n: 2, title: "ทำคอนเทนต์ให้คนเห็นและอยากซื้อ", courseId: "ai-sales-system" },
  { n: 3, title: "วาง Offer + สร้าง Landing Page", courseId: "ai-money-factory-2" },
  { n: 4, title: "รับเงิน + ส่งของอัตโนมัติ", courseId: "ai-money-factory-2" },
  { n: 5, title: "ระบบผลิตคอนเทนต์ด้วย AI", courseId: "ai-sales-system-pro" },
  { n: 6, title: "AI x Viral Framework", courseId: "ai-sales-system-pro" },
  { n: 7, title: "Scale ด้วย Ads", courseId: "ai-sales-system-pro" },
];

export const AMF_COURSE_IDS = [...new Set(AMF_MODULES.map((m) => m.courseId))];

export type Homework = {
  id: string;
  module: number;
  /** What to hand in, one item per line. */
  deliver: string[];
  /** How to tell it is done right. */
  pass: string[];
  time?: string;
};

export const HOMEWORK: Homework[] = [
  {
    id: "amf-hw-m1",
    module: 1,
    deliver: [
      "ตารางสำรวจ 8 เคส จาก Skool และ IG: ชื่อคอมมูนิตี้/เพจ, ขายอะไร, ราคา, ทำไมคุณคิดว่าเขาขายได้",
      "ลิสต์สกิลและงานอดิเรกของตัวเอง อย่างน้อย 10 ข้อ ห้ามตัดทิ้งเองระหว่างเขียน",
      "ไอเดียโปรดักต์ 1 อัน ที่เลือกมาแล้ว พร้อมเหตุผลว่าทำไมเลือกอันนี้",
      "ชื่อ offer 4 เวอร์ชัน: ตรงไปตรงมา 1 อัน + reframe อีก 3 อัน แล้วบอกว่าจะใช้อันไหน",
    ],
    pass: [
      "ชื่อที่เลือกต้องไม่ใช่เวอร์ชันตรงไปตรงมา (ถ้าเลือกอันตรงไปตรงมา แปลว่ายังไม่ได้ reframe)",
      "อ่านชื่อแล้วต้องไม่รู้สึกว่า \"ใครๆ ก็ขายแบบนี้\"",
    ],
    time: "2-3 ชั่วโมง",
  },
  {
    id: "amf-hw-m2",
    module: 2,
    deliver: [
      "จัดกลุ่มคอนเทนต์เก่าของตัวเอง (ถ้ายังไม่มี ใช้ของคู่แข่ง 10 ชิ้น) ว่าอันไหนเป็น Top / Middle / Bottom แล้วสรุปว่าคุณขาด funnel ไหนมากที่สุด",
      "ตาราง outlier จาก 5 ช่อง: ชื่อช่อง, วิวเฉลี่ยของช่อง, คลิปที่โดด, วิวของคลิปนั้น, หัวข้อคืออะไร",
      "เลือก 1 หัวข้อ แล้วเขียน hook 5 แบบ ในมุมของคุณเอง",
      "ลิงก์คอนเทนต์ที่โพสต์จริงจากบท 2.5 (ทำคอนเทนต์จริง 10 ชิ้น)",
    ],
    pass: [
      "ตาราง outlier ต้องเทียบกับฐานของช่องนั้น ช่องที่ปกติได้ 1,000 วิว แล้วมีคลิปเดียวได้ 10,000 วิว นับเป็น outlier",
      "hook ทั้ง 5 อันต้องผ่านคำถามเดียว: อ่านแล้วสงสัยไหม ถ้าอ่านแล้วเฉยๆ ให้เขียนใหม่",
    ],
    time: "2 ชั่วโมง + เวลาทำคอนเทนต์",
  },
  {
    id: "amf-hw-m3",
    module: 3,
    deliver: [
      "URL เว็บขายของคุณ ที่เปิดจากมือถือได้จริง",
      "Offer ของคุณเขียนเป็นข้อความสั้นๆ: ขายอะไร ให้ใคร ราคาเท่าไร ได้อะไรเมื่อไร",
    ],
    pass: [
      "headline มีทั้งเวลาและผลลัพธ์",
      "หลักฐานบนหน้าเว็บเป็นของจริงทั้งหมด และใหญ่พอๆ กับคำสัญญา",
      "มีรูปหน้าตัวเองอยู่บนหน้าเว็บ",
    ],
    time: "ตัวงานคือการทำเว็บในโมดูลนี้",
  },
  {
    id: "amf-hw-m4",
    module: 4,
    deliver: [
      "ลิงก์เว็บไซต์ของคุณที่ทำเสร็จแล้ว ใส่ในช่องลิงก์ด้านล่าง",
    ],
    pass: [
      "มีหน้าเว็บวาง offer ครบ: ขายอะไร ให้ใคร ราคาเท่าไร",
      "มีระบบจ่ายเงินที่กดซื้อและจ่ายได้จริง",
      "เปิดจากมือถือได้ ไม่มีส่วนไหนพัง",
    ],
  },
  {
    id: "amf-hw-m5",
    module: 5,
    deliver: [
      "ไฟล์ brand brief ที่เก็บอยู่ใน Project แล้ว",
      "ความเห็นที่ขัดแย้งกับคนในวงการ 1 ข้อ เขียนเป็นประโยคเดียวให้คม",
      "โพสต์ 1 ชิ้นที่ AI เขียนและได้คะแนนเกิน 9 พร้อมสกรีนช็อตคะแนน",
      "Carousel 1 ชุดใน Canva ที่เปลี่ยนรูป ชื่อ และ user ID เป็นของตัวเองแล้ว",
    ],
    pass: [
      "brand brief ต้องสร้างจากการแปะเนื้อหา offer ไม่ใช่พิมพ์อธิบายสั้นๆ",
      "ต้องมีรูปหน้าตัวเองอยู่ในคอนเทนต์",
      "คุณต้องแก้คอนเทนต์ที่ AI เขียนอย่างน้อย 1 จุด และบอกได้ว่าแก้เพราะอะไร",
    ],
    time: "2-3 ชั่วโมง",
  },
  {
    id: "amf-hw-m6",
    module: 6,
    deliver: [
      "ไฟล์ Top 10 หัวข้อ จาก Viral Spy",
      "บันทึกการตรวจสอบ: กดเข้า URL จริงอย่างน้อย 5 อัน แล้วจดว่าอันไหนใช้ได้ อันไหนหลอน/ตัวเลขไม่ตรง",
      "คอนเทนต์ 5 ชิ้น ที่ให้ Content Coach เขียนจากหัวข้อที่ผ่านการคัดแล้ว",
      "เลือกมา 1 ชิ้น โพสต์จริง แล้วบันทึกยอดหลัง 48 ชั่วโมง",
    ],
    pass: [
      "ต้องคัดหัวข้อทิ้งอย่างน้อย 1 อัน ถ้ารับมาหมดแปลว่ายังไม่ได้ตรวจ",
      "คอนเทนต์ที่เขียนต้องมีมุมหรือประสบการณ์ของคุณ ไม่ใช่สรุปของคนอื่นเฉยๆ",
    ],
    time: "2-3 ชั่วโมง",
  },
  {
    id: "amf-hw-m7",
    module: 7,
    deliver: [
      "สกรีนช็อต Events Manager ที่เห็น Purchase event ยิงเข้ามาจากเว็บของคุณ",
      "ads 1 แคมเปญ ที่ยิงไปหาคนที่เคยเห็นคอนเทนต์ (retarget) ด้วยงบทดสอบที่รับได้",
      "ตารางเทียบ 7 วัน: ยอดขายที่ Meta บอก เทียบกับยอดขายจริงใน Stripe",
    ],
    pass: [
      "ตัดสินใจเพิ่มหรือลดงบจากยอดใน Stripe ไม่ใช่จาก ROAS ใน Meta",
      "บอกได้ว่า ad ตัวไหนเริ่มอิ่มตัว (ความถี่เกิน 3)",
    ],
  },
];

export const HOMEWORK_TEXT_MAX = 3000;
export const HOMEWORK_LINK_MAX = 500;

/** Only http(s) links are kept; anything else (javascript:, typos) becomes "". */
export function cleanLink(raw: string): string {
  const v = raw.trim().slice(0, HOMEWORK_LINK_MAX);
  return /^https?:\/\/\S+$/i.test(v) ? v : "";
}
